import { forwardRef } from "react"

import { cn } from "../utils/tailwindcss"

export const Grid = forwardRef<
  HTMLDivElement,
  { children: React.ReactNode; className?: string }
>(function ({ children, className }, ref) {
  return (
    <div
      ref={ref}
      className={cn(
        "mx-2 lg:mx-4 grid grid-cols-4 md:grid-cols-8 lg:grid-cols-12 gap-2 lg:gap-4",
        className,
      )}
    >
      {children}
    </div>
  )
})

Grid.displayName = "Grid"
